import * as types from '../mutation-types'
import { api } from './../../modules/api'

const state = () => ({
  emailTemplates: [],
  emailTemplatesKeyAndId: [],
  totalPages: 0
})

const getters = {
  getEmailTemplates: state => state.emailTemplates,
  emailTemplatesKeyAndId: state => state.emailTemplatesKeyAndId
}

const actions = {
  async fetchEmailTemplates ({ commit }, payload = {}) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      const { data } = await this.$axios.get(api.emailTemplates.getEmailTemplates(payload))
      commit(types.SET_EMAIL_TEMPLATES, data)
      return data
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE, 'Didn`t fetch Email Templates')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async postEmailTemplates ({ commit, dispatch }, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      await this.$axios.post(api.emailTemplates.postEmailTemplate(), payload)
      await dispatch('fetchEmailTemplates')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Created Email Templates')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Didn`t create Email Templates')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateEmailTemplates ({ commit, dispatch }, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      await this.$axios.put(api.emailTemplates.putEmailTemplate(), payload)
      await dispatch('fetchEmailTemplates')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated Email Templates')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Didn`t update Email Templates')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteEmailTemplates ({ commit, dispatch }, { key, culture }) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      await this.$axios.delete(api.emailTemplates.deleteEmailTemplate(key, culture))
      await dispatch('fetchEmailTemplates')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Deleted Email Templates')
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE, 'Didn`t delete Email Templates')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editEmailTemplate ({ commit, dispatch }, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      await this.$axios.put(api.emailTemplates.editEmailTemplate(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Email templates successfully edited ')
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE, 'Didn`t Edit Email Templates')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_EMAIL_TEMPLATES] (state, data) {
    state.emailTemplates = data.emailTemplates
    state.emailTemplatesKeyAndId = data.emailTemplates.map(val => {
      return { templateKey: val.templateKey, emailTemplateId: val.id }
    })
    state.totalPages = data.totalPages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/emailTemplates.js